module.exports = __webpack_public_path__ + "img/Asset 2.cb12cf88.png";